<template>
    <div class="page-header">
        <div class="row align-items-end">
            <div class="col-sm mb-2 mb-sm-0">


                <BreadCrumb :breads="breads" />
                <h1 class="page-header-title bold">{{ title }}</h1>
            </div>
            <div class="col-sm-auto" v-if="action">
                <Action :to="action.to" :params="action.params" :title="action.title" />
            </div>


        </div>
    </div>
</template>
<script>
import Action from "./Action.vue";
import BreadCrumb from "./BreadCrumb.vue"
export default {
    name: "SubHeader",
    components: {
        BreadCrumb,
        Action
    },
    props: {
        breads: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        action:{
            type:Object
        }
    }
}
</script>